module.exports = __webpack_public_path__ + "img/whatsapp-svgrepo-com.afd827ab.svg";